export class WorldTrigger extends Phaser.GameObjects.Zone {
  constructor(scene, layer, config) {
    super(scene, config.x, config.y, config.width, config.height);
    this.setOrigin(0);
    layer.add(this);

    this.type = config.type;
    this.id = config.name;
    this.name = config.name;

    this._trigegrEvent = config.trigger;
    this._destroyOnTrigger = config.destroyOnTrigger;
    this._colliderCollision = new Phaser.Geom.Rectangle(this.x, this.y, this.width, this.height);
    scene.collisionMap.addWorldTrigger(this);
  }

  get left() {
    return this.x - this.width * 0.5;
  }
  get right() {
    return this.x + this.width * 0.5;
  }
  get top() {
    return this.y - this.height * 0.5;
  }
  get bottom() {
    return this.y + this.height * 0.5;
  }
  get colliderCollision() {
    return this._colliderCollision;
  }

  trigger() {
    this.scene.events.emit(this._trigegrEvent, this);
    if (this._destroyOnTrigger) this.destroy();
  }

  disable() {
    this.active = false;
  }

  destroy() {
    this.scene.collisionMap.removeWorldTrigger(this);
    super.destroy();
  }
}
